<template>
  <div class="h-100">
    <CRow class="h-100">
      <CCol class="h-100 px-2">
        <CCard accent-color="info" class="h-100 card-scroll-y">
          <CCardHeader class="px-3">
            <CRow>
              <CCol col="8">
                <h4 class="text-uppercase mb-0">
                  Thông báo đẩy
                </h4>
              </CCol>
            </CRow>
          </CCardHeader>
          <CCardBody class="p-3">
            <CRow class="h-100">
              <CCol md="6">
                <CCard border-color="info" class="mb-3">
                  <CCardHeader class="px-3 font-weight-bold">
                    <CIcon name="cil-pen-alt"/>
                    Đăng ký thông báo đẩy
                  </CCardHeader>
                  <CCardBody class="p-3">
                    <!--                    <CRow class="mb-2">-->
                    <!--                      <CCol col="3">-->
                    <!--                        <label class="mb-0 mt-1">Ảnh tiêu đề</label>-->
                    <!--                      </CCol>-->
                    <!--                      <CCol col="9">-->
                    <!--                        <div class="position-relative">-->
                    <!--                          <CRow>-->
                    <!--                            <b-img-->
                    <!--                              rounded-->
                    <!--                              @click="$refs.titleImage.$el.childNodes[0].click()"-->
                    <!--                              style="margin: auto"-->
                    <!--                              blank-color="#777"-->
                    <!--                              v-if="titleImageUploader.src"-->
                    <!--                              :src="titleImageUploader.src"-->
                    <!--                              variant="light" size="25rem" badge-offset="3px"-->
                    <!--                              class="mt-5 avatar-user-detail cursor-pointer"-->
                    <!--                              title="Ảnh tiêu đề">-->
                    <!--                            </b-img>-->

                    <!--                          </CRow>-->
                    <!--                          <CElementCover-->
                    <!--                            v-if="titleImageUploader.status === 'uploading'"-->
                    <!--                            :boundaries="[{ sides: ['top', 'left'], query: '.media-body' }]"-->
                    <!--                            :opacity="0.8"-->
                    <!--                          >-->
                    <!--                            <h1 class="d-inline">{{ titleImageUploader.status }}</h1>-->
                    <!--                            <CProgress-->
                    <!--                              v-if="titleImageUploader.percent!==100"-->
                    <!--                              :value="titleImageUploader.percent"-->
                    <!--                              color="success"-->
                    <!--                              animated-->
                    <!--                              show-value-->
                    <!--                              style="-->
                    <!--                          margin: 10px;-->
                    <!--                          height:10px;"-->
                    <!--                            />-->
                    <!--                          </CElementCover>-->

                    <!--                        </div>-->

                    <!--                        <div class="w-100">-->
                    <!--                          <CButton v-if="!titleImageUploader.src"-->
                    <!--                                   color="success"-->
                    <!--                                   class="px-3 mr-2"-->
                    <!--                                   @click="$refs.titleImage.$el.childNodes[0].click()">-->
                    <!--                            Chọn ảnh-->
                    <!--                          </CButton>-->
                    <!--                        </div>-->


                    <!--                        <b-form-file-->
                    <!--                          aria-invalid="input-ads-image"-->
                    <!--                          class="d-none"-->
                    <!--                          ref="titleImage"-->
                    <!--                          accept="image/*"-->
                    <!--                          @change="onChangeTitleImage"></b-form-file>-->


                    <!--                      </CCol>-->

                    <!--                    </CRow>-->

                    <CRow class="mb-2">
                      <CCol col="3">
                        <label class="mb-0 mt-1">Tiêu đề</label>
                      </CCol>
                      <CCol col="9">
                        <b-form-input v-model="formData.title" placeholder="Nhập tiêu đề..."></b-form-input>
                      </CCol>
                    </CRow>

                    <CRow class="mb-2">
                      <CCol col="3">
                        <label class="mb-0">Nội dung</label>
                      </CCol>
                      <CCol col="9">
                        <b-form-textarea
                          id="text-notif-content"
                          v-model="formData.description"
                          placeholder="Nhập nội dung..."
                          rows="3"
                          max-rows="3"
                        ></b-form-textarea>
                      </CCol>
                    </CRow>

                    <CRow class="mb-2">
                      <CCol col="3">
                        <label class="mb-0">Loại thông báo</label>
                      </CCol>
                      <CCol col="9">
                        <div class="form-check">
                          <input class="form-check-input" type="radio"
                                 name="flexRadioDefault" id="flexRadioDefault1">
                          <label class="form-check-label" for="flexRadioDefault1">
                            Hệ thống
                          </label>
                        </div>
                        <div class="form-check">
                          <input class="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault2"
                                 ref="check_offer"
                                 checked>
                          <label class="form-check-label" for="flexRadioDefault2">
                            Khuyến mãi
                          </label>
                        </div>
                      </CCol>
                    </CRow>

                    <CCol :col="{ size: 2, offset: 10 }">
                      <CRow class="mb-2 mt-4">
                        <CButton block color="success" @click="pushNotification">Đẩy thông báo</CButton>
                      </CRow>
                    </CCol>

                  </CCardBody>
                </CCard>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import {firebaseStorage} from '@/mixins/firebaseStorage'
import {mapActions} from 'vuex'
import * as _ from "lodash";
import {SHOW_TOAST_2} from "@/common/lib";

export default {
  name: 'CreateOrUpdate',
  mixins: [
    firebaseStorage
  ],
  data() {
    return {
      formData: {
        title: '',
        description: '',
        image: '',
        type: 2,
      },
      titleImageUploader: {},
    }
  },
  methods: {
    ...mapActions('notif', ['createNotif']),
    async onChangeTitleImage(e) {
      const files = e.target.files
      if (files.length === 0 || !files) return
      const file = files[0]
      if (!file) return

      this.titleImageUploader = this.createUploader(file)
      this.formData.image = await this.uploadToFirebaseStorage(this.titleImageUploader)
    },

    async pushNotification() {
      this.formData.type = this.$refs.check_offer.checked ? 2 : 1
      const confirm = window.confirm(`Thông báo sẽ được gửi đến tất cả các thiết bị đang cài đặt Dakland, bạn có muốn tiếp tục?`)
      if (!confirm) return
      const res = await this.createNotif(this.formData)
      if (res === 'success') {
        SHOW_TOAST_2('success', 'Đã gửi thông báo đẩy!')
      } else {
        SHOW_TOAST_2('error', 'Không thể gửi thông báo đẩy. Vui lòng thử lại!')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
</style>
